export default {
  Total: "All18",
  All18: "All 18",
  Front: "F9",
  Back: "B9",
};
